import { Injectable } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class MultiSelectModel {
  multiSelectSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'Id',
    textField: 'Label',
    selectAllText: 'Sélectionner tout',
    unSelectAllText: 'Désélectionner tout',
    itemsShowLimit: 2,
    allowSearchFilter: false,
    enableCheckAll: true,
    noDataAvailablePlaceholderText: 'Pas de données disponibles',
    closeDropDownOnSelection: false,
    searchPlaceholderText: 'Rechercher'
  }

  public getAllowSearchFilter(allowSearchFilter?: boolean) {
    const multiSelectSettings = Object.assign({}, this.multiSelectSettings);
    if (!_.isNil(allowSearchFilter)) {
      multiSelectSettings.allowSearchFilter = allowSearchFilter;
    }
    return multiSelectSettings
  }

  public getSingleSelection(singleSelection?: boolean, allowSearchFilter?: boolean) {
    const multiSelectSettings = Object.assign({}, this.multiSelectSettings);
    if (!_.isNil(singleSelection)) {
      multiSelectSettings.singleSelection = singleSelection;
      multiSelectSettings.closeDropDownOnSelection = !!singleSelection;
    }
    if (!_.isNil(allowSearchFilter)) {
      multiSelectSettings.allowSearchFilter = allowSearchFilter;
    }
    return multiSelectSettings
  }

  public getMultipleSelection(allowSearchFilter?: boolean) {
    const multiSelectSettings = Object.assign({}, this.multiSelectSettings);
    if (!_.isNil(allowSearchFilter)) {
      multiSelectSettings.allowSearchFilter = allowSearchFilter;
    }
    return multiSelectSettings
  }

  public getSettings(idField?: string, textField?: string, singleSelection?: boolean, allowSearchFilter?: boolean, closeDropDownOnSelection?: boolean, enableCheckAll?: boolean, searchPlaceholderText?: string, itemsShowLimit?: number, allowRemoteDataSearch?: boolean) {
    const multiSelectSettings = Object.assign({}, this.multiSelectSettings);
    if (!_.isNil(idField)) {
      multiSelectSettings.idField = idField;
    }
    if (!_.isNil(textField)) {
      multiSelectSettings.textField = textField;
    }
    if (!_.isNil(searchPlaceholderText)) {
      multiSelectSettings.searchPlaceholderText = searchPlaceholderText;
    }
    if (!_.isNil(singleSelection)) {
      multiSelectSettings.singleSelection = singleSelection;
    }
    if (!_.isNil(allowSearchFilter)) {
      multiSelectSettings.allowSearchFilter = allowSearchFilter;
    }
    if (!_.isNil(closeDropDownOnSelection)) {
      multiSelectSettings.closeDropDownOnSelection = closeDropDownOnSelection;
    }
    if (!_.isNil(enableCheckAll)) {
      multiSelectSettings.enableCheckAll = enableCheckAll;
    }
    if (!_.isNil(itemsShowLimit)) {
      multiSelectSettings.itemsShowLimit = itemsShowLimit;
    }
    if (!_.isNil(allowRemoteDataSearch)) {
      multiSelectSettings.allowRemoteDataSearch = allowRemoteDataSearch;
    }
    return multiSelectSettings;
  }
}
